/* Nurturi — global.js
   Deferred, dependency-free. Drawers, AJAX cart (Section Rendering API), countdown.
   Public API: window.Nurturi { addToCart, changeLine, openCart, formatMoney } */
(function () {
  'use strict';

  /* ---------- config ---------- */
  var cfg = { routes: {}, moneyFormat: '${{amount}}', freeShipping: false, freeShippingThreshold: 0, strings: {} };
  try {
    var el = document.getElementById('nt-config');
    if (el) cfg = Object.assign(cfg, JSON.parse(el.textContent));
  } catch (e) { /* keep defaults */ }

  var CART_SECTION = 'cart-drawer';

  /* ---------- money ---------- */
  function formatMoney(cents) {
    cents = parseInt(cents, 10) || 0;
    var whole = cents % 100 === 0;            // drop trailing .00 (match money_without_trailing_zeros)
    var value = (cents / 100).toFixed(whole ? 0 : 2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    return cfg.moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/g, amount);
  }

  /* ---------- drawers ---------- */
  var lastFocus = null;

  function lockScroll() {
    var sw = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (sw > 0) document.body.style.paddingRight = sw + 'px';
  }
  function unlockScroll() {
    if (document.querySelector('.drawer.is-open')) return;
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }
  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    // Commit the closed transform first so a freshly re-rendered drawer (add-to-cart swaps
    // the section innerHTML) slides in instead of snapping straight to the open position.
    var panel = drawer.querySelector('.drawer__panel');
    if (panel) void panel.offsetWidth;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll();
    var focusable = drawer.querySelector('.drawer__close, a, button, input');
    if (focusable) focusable.focus();
    document.addEventListener('keydown', onKeydown);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockScroll();
    document.removeEventListener('keydown', onKeydown);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function closeAll() {
    document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
  }
  function onKeydown(e) {
    if (e.key === 'Escape') { closeAll(); return; }
    if (e.key !== 'Tab') return;
    var open = document.querySelector('.drawer.is-open .drawer__panel');
    if (!open) return;
    var f = open.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function cartDrawer() { return document.querySelector('[data-cart-drawer]'); }

  /* ---------- header cart indicator ---------- */
  function updateHeaderCount(count) {
    document.querySelectorAll('[data-cart-dot]').forEach(function (d) { d.classList.toggle('is-on', count > 0); });
    document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = count; });
  }

  /* ---------- toast ---------- */
  function toast(msg) {
    var t = document.createElement('div');
    t.setAttribute('role', 'status');
    t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:200;background:#0B1F2A;color:#fff;font-size:13px;font-weight:600;padding:11px 18px;border-radius:999px;box-shadow:0 10px 30px rgba(11,31,42,.25);max-width:90vw;text-align:center';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.style.transition = 'opacity .4s'; t.style.opacity = '0'; }, 2200);
    setTimeout(function () { t.remove(); }, 2700);
  }

  /* ---------- cart ---------- */
  function refreshCartSection(sectionsHtml) {
    if (!sectionsHtml) return;
    var doc = new DOMParser().parseFromString(sectionsHtml, 'text/html');
    var fresh = doc.querySelector('#shopify-section-' + CART_SECTION);
    var current = document.querySelector('#shopify-section-' + CART_SECTION);
    if (fresh && current) {
      var wasOpen = current.querySelector('.drawer.is-open');
      current.innerHTML = fresh.innerHTML;
      var root = current.querySelector('[data-cart-drawer]');
      if (root) {
        updateHeaderCount(parseInt(root.getAttribute('data-cart-total-count'), 10) || 0);
        if (wasOpen) root.classList.add('is-open'), root.setAttribute('aria-hidden', 'false');
      }
      initReserveTimers();
      if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) Shopify.PaymentButton.init();
    }
  }

  function addToCart(items, opts) {
    opts = opts || {};
    var body = { items: Array.isArray(items) ? items : [items], sections: CART_SECTION, sections_url: window.location.pathname };
    return fetch(cfg.routes.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.data.description || res.data.message || 'Could not add to cart'); throw res.data; }
        refreshCartSection(res.data.sections && res.data.sections[CART_SECTION]);
        if (opts.openCart !== false) openDrawer(cartDrawer());
        document.dispatchEvent(new CustomEvent('nurturi:cart:added', { detail: res.data }));
        return res.data;
      });
  }

  function changeLine(key, quantity, extraSection) {
    var sections = extraSection ? CART_SECTION + ',' + extraSection : CART_SECTION;
    var body = { id: key, quantity: quantity, sections: sections, sections_url: window.location.pathname };
    return fetch(cfg.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); })
      .then(function (data) {
        refreshCartSection(data.sections && data.sections[CART_SECTION]);
        // cart page: swap the main-cart section in place instead of a full reload
        if (extraSection && data.sections && data.sections[extraSection]) {
          var wrap = document.getElementById('shopify-section-' + extraSection);
          if (wrap) {
            var doc = new DOMParser().parseFromString(data.sections[extraSection], 'text/html');
            var fresh = doc.getElementById('shopify-section-' + extraSection);
            wrap.innerHTML = fresh ? fresh.innerHTML : data.sections[extraSection];
          }
        }
        document.dispatchEvent(new CustomEvent('nurturi:cart:updated', { detail: data }));
        return data;
      });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-toggle],[data-menu-toggle],[data-drawer-close],[data-qty-up],[data-qty-down],[data-line-remove],[data-add-to-cart]');
    if (!t) return;

    if (t.hasAttribute('data-cart-toggle')) { e.preventDefault(); openDrawer(cartDrawer()); return; }
    if (t.hasAttribute('data-menu-toggle')) { e.preventDefault(); openDrawer(document.querySelector('[data-mobile-menu]')); return; }
    if (t.hasAttribute('data-drawer-close')) { e.preventDefault(); closeDrawer(t.closest('.drawer')); return; }

    var line = t.closest('[data-line-key]');
    // cart PAGE lines (not the drawer) re-render their own section via the same API call — no reload
    var pageWrap = null;
    if (line && !line.closest('[data-cart-drawer]')) pageWrap = line.closest('[id^="shopify-section-"]');
    var pageSection = pageWrap ? pageWrap.id.replace('shopify-section-', '') : null;
    if (line && (t.hasAttribute('data-qty-up') || t.hasAttribute('data-qty-down'))) {
      e.preventDefault();
      var input = line.querySelector('[data-qty-input]');
      var q = parseInt(input.value != null ? input.value : input.textContent, 10) || 1;
      q = t.hasAttribute('data-qty-up') ? q + 1 : Math.max(1, q - 1); // stepper floors at 1; removal is the ✕
      changeLine(line.getAttribute('data-line-key'), q, pageSection);
      return;
    }
    if (line && t.hasAttribute('data-line-remove')) {
      e.preventDefault();
      changeLine(line.getAttribute('data-line-key'), 0, pageSection);
      return;
    }

    if (t.hasAttribute('data-add-to-cart')) {
      var id = t.getAttribute('data-variant-id');
      if (!id) return; // multi-variant cards link to the product page instead
      e.preventDefault();
      t.classList.add('is-loading');
      addToCart({ id: id, quantity: 1 }).finally(function () { t.classList.remove('is-loading'); });
    }
  });

  /* ---------- collection sort ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort]');
    if (!sel) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* ---------- countdown ---------- */
  function pad(n) { return String(n).padStart(2, '0'); }
  function initCountdown(node) {
    var mode = node.getAttribute('data-mode') || 'rolling';
    var days = parseInt(node.getAttribute('data-days'), 10) || 3;
    var windowMs = days * 86400000;
    var KEY = 'nt_sale_end';

    function endTime() {
      if (mode === 'fixed') {
        var raw = (node.getAttribute('data-end') || '').trim().replace(' ', 'T');
        var t = Date.parse(raw);
        return isNaN(t) ? Date.now() + windowMs : t;
      }
      var stored = parseInt(localStorage.getItem(KEY), 10);
      if (!stored || isNaN(stored) || stored <= Date.now()) {
        stored = Date.now() + windowMs;
        try { localStorage.setItem(KEY, String(stored)); } catch (e) {}
      }
      return stored;
    }

    var fields = {
      days: node.querySelector('[data-cd="days"]'),
      hours: node.querySelector('[data-cd="hours"]'),
      minutes: node.querySelector('[data-cd="minutes"]'),
      seconds: node.querySelector('[data-cd="seconds"]')
    };

    function tick() {
      var diff = endTime() - Date.now();
      if (diff < 0) diff = 0;
      if (fields.days) fields.days.textContent = pad(Math.floor(diff / 86400000));
      if (fields.hours) fields.hours.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if (fields.minutes) fields.minutes.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (fields.seconds) fields.seconds.textContent = pad(Math.floor((diff % 60000) / 1000));
    }
    tick();
    setInterval(tick, 1000);
  }
  document.querySelectorAll('[data-countdown]').forEach(initCountdown);

  /* ---------- reserve timer (cosmetic urgency, drawer footer) ---------- */
  var reserveTimer = null;
  function initReserveTimers() {
    if (reserveTimer) { clearInterval(reserveTimer); reserveTimer = null; }
    var node = document.querySelector('[data-reserve-timer]');
    if (!node) return;
    var clock = node.querySelector('[data-reserve-clock]');
    if (!clock) return;
    var secs = parseInt(node.getAttribute('data-reserve-seconds'), 10) || 600;
    var KEY = 'nt_cart_reserve';
    var end = parseInt(localStorage.getItem(KEY), 10);
    if (!end || isNaN(end) || end <= Date.now()) {          // fresh window; persists across renders/reloads
      end = Date.now() + secs * 1000;
      try { localStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    function tick() {
      var diff = end - Date.now();
      if (diff < 0) diff = 0;
      clock.textContent = pad(Math.floor(diff / 60000)) + ':' + pad(Math.floor((diff % 60000) / 1000));
      if (diff <= 0 && reserveTimer) { clearInterval(reserveTimer); reserveTimer = null; }
    }
    tick();
    reserveTimer = setInterval(tick, 1000);
  }
  initReserveTimers();

  /* ---------- footer menu columns ----------
     <details> accordions on mobile; on desktop they must be OPEN — modern engines hide a
     closed <details>' content at the engine level, so CSS alone can't force it visible.
     Desktop: set open. Back to mobile: reset to the default collapsed state. */
  (function () {
    var mq = window.matchMedia('(min-width: 990px)');
    function footCols() {
      document.querySelectorAll('.nrt-footer details.nrt-col').forEach(function (d) {
        d.open = mq.matches;
      });
    }
    footCols();
    if (mq.addEventListener) mq.addEventListener('change', footCols);
    else if (mq.addListener) mq.addListener(footCols);
  })();

  /* ---------- deferred below-fold images ----------
     snippets/responsive-image.liquid (defer: true) emits data-src/data-srcset. They get their
     real src once the page's LCP image (the one with fetchpriority=high) has loaded — or on
     window load, or after 3 s, whichever is first — so they never share the connection with
     it. A scroller who gets there first is covered by the observer — 0px margin on purpose:
     with a look-ahead, the first below-fold section on a phone sits inside it and hydrated
     immediately, putting the stage photos back on the connection during the hero download. */
  (function () {
    var pending = Array.prototype.slice.call(document.querySelectorAll('img.rimg-defer[data-src]'));
    if (!pending.length) return;
    function hydrate(img) {
      if (!img.getAttribute('data-src')) return;
      if (img.getAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset'));
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src'); img.removeAttribute('data-srcset');
      img.classList.remove('rimg-defer');
    }
    var done = false;
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { hydrate(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '0px' }) : null;
    function hydrateAll() { if (done) return; done = true; pending.forEach(hydrate); if (io) io.disconnect(); }
    if (io) pending.forEach(function (img) { io.observe(img); });
    /* The page's hero, not the header logo — the logo also carries fetchpriority=high and,
       being 6 KB, finishes long before the hero, which released the images too early. */
    var lcp = document.querySelector('#MainContent img[fetchpriority="high"]');
    if (!lcp || lcp.complete) hydrateAll();
    else lcp.addEventListener('load', hydrateAll, { once: true });
    window.addEventListener('load', hydrateAll, { once: true });
    setTimeout(hydrateAll, 3000);
  })();

  /* ---------- product-card hover image ----------
     The second image ships as data-src (snippets/product-card.liquid). On the card's first
     mouseenter it gets its src; once loaded it is marked ready and the CSS crossfades it in
     while the card is hovered. Pointer devices only. */
  (function () {
    if (!(window.matchMedia && window.matchMedia('(hover: hover)').matches)) return;
    document.querySelectorAll('.product-card').forEach(function (card) {
      var alt = card.querySelector('.product-card__alt[data-src]');
      if (!alt) return;
      card.addEventListener('mouseenter', function () {
        if (!alt.getAttribute('data-src')) return;
        alt.addEventListener('load', function () { alt.classList.add('is-ready'); }, { once: true });
        if (alt.getAttribute('data-srcset')) alt.setAttribute('srcset', alt.getAttribute('data-srcset'));
        alt.setAttribute('src', alt.getAttribute('data-src'));
        alt.removeAttribute('data-src'); alt.removeAttribute('data-srcset');
      }, { once: true });
    });
  })();

  /* ---------- expose ---------- */
  window.Nurturi = {
    addToCart: addToCart,
    changeLine: changeLine,
    openCart: function () { openDrawer(cartDrawer()); },
    formatMoney: formatMoney,
    toast: toast
  };
})();

/* Homepage sections reveal on scroll — staggered cascade, index template only.
   Decomposes each below-fold section into its content items (heads, cards, prose) and reveals
   them with a per-item delay, like the Our Story page. Content shows without JS / reduced-motion. */
(function () {
  if (!document.body || !document.body.classList.contains('template-index')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var main = document.getElementById('MainContent');
  if (!main) return;
  var GRIDS = '.section-head,.benefit-strip,.stage-cards,.coll-grid,.value-cards,.ugc-grid,.founder';
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('rv-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
  var sections = main.querySelectorAll(':scope > .shopify-section');
  /* Read every section's position FIRST, then mutate. Reading a rect after the previous
     iteration added classes forces a synchronous layout per section (Lighthouse: ~30 ms of
     forced reflow on the home page); one read pass up front makes it a single layout. */
  var vh = window.innerHeight || 0, belowFold = [];
  for (var s = 1; s < sections.length; s++) {                 /* skip [0] = hero (above the fold) */
    belowFold[s] = sections[s].getBoundingClientRect().top > vh;
  }
  for (var s = 1; s < sections.length; s++) {
    var sec = sections[s];
    if (!belowFold[s]) continue;
    var wrap = sec.firstElementChild;
    if (!wrap) continue;
    var items = [];
    Array.prototype.forEach.call(wrap.children, function (block) {
      if (block.matches && block.matches(GRIDS) && block.children.length) {
        Array.prototype.forEach.call(block.children, function (k) { items.push(k); });
      } else {
        items.push(block);
      }
    });
    if (!items.length) continue;
    items.forEach(function (el, i) {
      el.classList.add('hp-rev');
      el.style.setProperty('--d', Math.min(i * 0.07, 0.42) + 's');
    });
    io.observe(sec);
  }
})();
